import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CalendarBlank, CaretDown, CaretUp } from "@phosphor-icons/react";

const PAGE = 5;

export const ClientSchedule = () => {
  const [orders, setOrders] = useState(null);
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    api.get("/schedule").then((r) => setOrders((r.data.clients || []).flatMap((c) => c.orders))).catch(() => setOrders([]));
  }, []);
  if (!orders || orders.length === 0) return null;
  const units = orders.reduce((s, o) => s + (o.items || []).reduce((a, it) => a + (Number(it.quantity) || 0), 0), 0);
  const shown = expanded ? orders : orders.slice(0, PAGE);
  const hidden = orders.length - PAGE;
  return (
    <div className="rounded-lg border border-border bg-card overflow-hidden" data-testid="client-schedule">
      <div className="flex items-center justify-between gap-3 px-4 sm:px-5 py-3 border-b border-border bg-muted/40">
        <h3 className="font-heading font-semibold flex items-center gap-2 text-sm sm:text-base"><CalendarBlank size={18} className="shrink-0" /> Schedule — being prepared for dispatch</h3>
        <p className="text-xs text-muted-foreground whitespace-nowrap" data-testid="client-schedule-summary">{orders.length} order(s) · {units} unit(s)</p>
      </div>
      <table className="w-full text-sm table-fixed">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-muted-foreground border-b border-border">
            <th className="px-4 sm:px-5 py-2 font-medium w-[32%]">PTN name</th>
            <th className="px-2 py-2 font-medium">Product · Qty</th>
            <th className="px-4 sm:px-5 py-2 font-medium w-[24%] text-right">Order</th>
          </tr>
        </thead>
        <tbody>
          {shown.map((o) => (
            <tr key={o.order_number} className="border-b border-border/50 last:border-0 align-top" data-testid={`client-schedule-row-${o.order_number}`}>
              <td className="px-4 sm:px-5 py-2 font-medium break-words">{o.patient_name || "—"}</td>
              <td className="px-2 py-2">
                {(o.items?.length ? o.items : [{ name: "—", quantity: "" }]).map((it, i) => (
                  <div key={i} className="flex justify-between gap-2"><span className="break-words">{it.name}</span><span className="tabular-nums text-muted-foreground shrink-0">×{it.quantity}</span></div>
                ))}
              </td>
              <td className="px-4 sm:px-5 py-2 text-right text-muted-foreground text-xs sm:text-sm">{o.order_number}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {hidden > 0 && (
        <div className="px-4 py-2 border-t border-border bg-muted/20 text-center">
          <Button variant="ghost" size="sm" className="rounded-sm h-8 text-primary" onClick={() => setExpanded((v) => !v)} data-testid="client-schedule-toggle">
            {expanded ? <><CaretUp size={14} className="mr-1.5" /> Show less</> : <><CaretDown size={14} className="mr-1.5" /> Show {hidden} more</>}
          </Button>
        </div>
      )}
    </div>
  );
};
